'use strict';

/**
 * Questionnaire base component that asks questions like chatbot
 * 
 * 
 */

import React from 'react';
import BotChatBubble from "./../BotChatBubble/BotChatBubble.jsx";
import CodingSystemTranslator from "./../../Documental/View/CodingSystemTranslator.js";
import i18n from  "./../../Documental/Localization/i18n.js";
import TopicMatrix from './../TopicMatrix/TopicMatrix.jsx';

// import StateMachine   from '../node_modules/react-simple-state/dist/';
// const appState = new StateMachine();

class BotQuestionnaireResult extends React.Component {

  constructor(props) {
    super(props);

    this.codingTranslator = new CodingSystemTranslator();
    this.showHidetimer = null;
    
    let displayState = 'initial';
    if( typeof props.cardDisplayState ){
      displayState = props.cardDisplayState;
    }
    
    let canMoveBackwards = false;
    if( typeof props.canMoveBackwards != 'undefined' ){
      canMoveBackwards = props.canMoveBackwards;
    }

    this.state = {
      cardDisplayState : displayState,
      canMoveOn : false,
      canMoveBackwards : canMoveBackwards,

      explainDialogOpened: false,
      explainDialogTitle : '',
      explainDialogContent : '',
      
      finishDialogOpened: false
    };

    this.handleMoveBack = this.handleMoveBack.bind( this );
    this.handleMoveOn = this.handleMoveOn.bind( this );
    this.handleFinish = this.handleFinish.bind( this );
    this.handleExplainClose = this.handleExplainClose.bind( this );
    this.handleExplainOpen  = this.handleExplainOpen.bind( this );
    this.handleFinishClose  = this.handleFinishClose.bind( this );
    
  }
  
  
  static getDerivedStateFromProps(nextProps, prevState) {
    
    if (nextProps.cardDisplayState !== prevState.cardDisplayState) {
      console.log( 'getDerivedStateFromProps:' );
      return {
        cardDisplayState: prevState.cardDisplayState,
      };
    } else {
      return null;
    }
  }
  
  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.cardDisplayState !== this.props.cardDisplayState ) {
      console.log( 'componentDidUpdate:' );
      this.setState({
        cardDisplayState: this.props.cardDisplayState,
      });

      this.renderAnimationsAfterDisplayStateChange();
    }
  }


  componentDidMount() {
    this.renderAnimationsAfterDisplayStateChange();
  }


  renderAnimationsAfterDisplayStateChange(){
		var that = this;
    
    if( this.showHidetimer != null ){
      clearTimeout( this.showHidetimer );
    }

    // Card gets intitially animated in after initial render (or also if re-shown in future)
		this.showHidetimer = setTimeout( function(){
      if( that.state.cardDisplayState == 'initial' ){
        that.setState({
          cardDisplayState : 'shown'
        });
        that.showHidetimer = null;
      }
		}, 400 );
  }

  
  
  /**
   * 
   */
  handleMoveOn( ){
  }


  /**
   * 
   * 
   * @return void
   */
   handleExplainOpen( event, obj ){
    this.setState({
      explainDialogOpened : true,
      explainDialogTitle : obj.title,
      explainDialogContent : obj.infoText
    });
  }



  /**
   * 
   * 
   * @return void
   */
   handleExplainClose(){
    // 
    this.setState({
      explainDialogOpened : false
    });

  }


  /**
   * 
   * 
   * @return void
   */
   handleFinishSelected( status ){
    // 
    this.setState({
      finishDialogOpened : false
    });

    //code	: in-progress | completed | amended | entered-in-error | stopped
    window.qHolder.setCurrentQuestionnaireResponseStatus( status, true );

    /*
    var currentToolSet = appState.getState( 'toolset' );
    
    let navigateTo = currentToolSet.getDefaultNavigationObject();
    navigateTo.mainContent = "questionnaireDone";
    window.eventsEmitter.emit( 'navigate-to', navigateTo );
    */
  }


  /**
   * 
   * 
   * @return void
   */
   handleFinishClose(){
    // 
    this.setState({
      finishDialogOpened : false
    });
  }
    
  /**
   * 
   */
  handleMoveBack( ){
    this.props.onQuestionAnswered( 'FAKE.1.1', ['FAKE.1.1.D'] );
  }


  /**
    * 
    */
  handleFinish( ){
    // this.props.onFinishRequst();
    this.setState({
      finishDialogOpened : true
    });
  }

  
  render() {
    
		let classNames  = 'card-animate';

		if( this.state.cardDisplayState == 'shown' ){
			classNames = classNames + ' card-show';
		} else if( this.state.cardDisplayState == 'closed' ){
			classNames = classNames + ' card-hide';
		}

    var that = this;

    let actionClasses = 'mdl-card__actions actions-hide';

    if( this.props.canFinish || this.state.canMoveOn || this.state.canMoveBackwards ){
      actionClasses = 'mdl-card__actions actions-show';
    }

    let translatedBtnForward = i18n.t( 'Next' );
    let translatedBtnBack = i18n.t( 'Continue filling' );
    let translatedBtnFinish = i18n.t( 'Finish' );
    

    // resultLogo = 'https://cdn1.iconfinder.com/data/icons/business-colored-5/64/Business_MountainsStationery_Success-512.png';
    // https://static.thenounproject.com/png/2524440-200.png medical team 
    // docktor https://img.icons8.com/wired/2x/medical-doctor.png
    // https://eeagrants.org/sites/default/files/Judicial%20Cooperation-1_0.svg 
    // https://uxestonia.ee/wp-content/uploads/2020/02/icon-light_on.svg
    // https://uxestonia.ee/wp-content/uploads/2020/02/icons-hot_chocolate.svg 
    // https://uxestonia.ee/wp-content/uploads/2020/02/icon-website-2.svg 
    // https://uxestonia.ee/wp-content/uploads/2020/02/icon-mission-2.svg 
    // https://uxestonia.ee/wp-content/uploads/2020/07/icon-rocket.svg
    // 

    let min = 1;
    let max = 3;
    let rnd = parseInt( Math.random() * (max - min) + min, 10 );
    let successIcons = [
      'https://uxestonia.ee/wp-content/uploads/2020/07/icon-rocket.svg',
      'https://uxestonia.ee/wp-content/uploads/2020/07/icon-rocket.svg',
      'https://uxestonia.ee/wp-content/uploads/2020/02/icons-hot_chocolate.svg',
      'https://cdn1.iconfinder.com/data/icons/business-colored-5/64/Business_MountainsStationery_Success-512.png',
      'https://cdn1.iconfinder.com/data/icons/business-colored-5/64/Business_MountainsStationery_Success-512.png'
    ];

    
    let resMood = 'result-neutral';
    let resultLogo = successIcons[ rnd ];
    let resultstitle = 'Here are the current results. ';

    let lang = i18n.language;
    if( lang == 'ru' ){
      resultstitle = 'Вот текущие результаты.';
    }
    if( lang == 'et' ){
      resultstitle = 'Tulemused hetkeseisuga';
    }

    if( this.props.resultType == 'not-enough-info' ) {
      // resMood = 'result-bad';
      resultstitle = 'Not enough info yet to show more results. Please continue filling for better results. ';
      resultLogo = 'https://cdn3.iconfinder.com/data/icons/abstract-1/512/Incomplete-512.png';
      
      if( lang == 'ru' ){
        resultstitle = 'Пока недостаточно информации, чтобы показать больше результатов. Пожалуйста, продолжайте заполнять для лучших результатов. ';
      }
      if( lang == 'et' ){
        resultstitle = 'Rohkemate andmete kuvamiseks pole veel piisavalt teavet. Paremate tulemuste saavutamiseks jätkake täitmist.';
      }

    }

    let classes2 = "mdl-card-wide mdl-card results-card " + resMood + " mdl-shadow--2dp;";

    let explainDialogClasses = "modal-container-general";
    if( this.state.explainDialogOpened ){
      explainDialogClasses = explainDialogClasses + ' opened';
    }
    

    let finishDialogClasses = "modal-container-general";
    if( this.state.finishDialogOpened ){
      finishDialogClasses = finishDialogClasses + ' opened';
    }
    

		let botText = [
			{
				"text" : resultstitle,
				"loader" : false
			}
		];

    let topicText = '';
    let topicColorClass = "red";

    let matrixContent = window.qHolder.getCurrentQuestionnaireResponseMatrix( lang );

    
    let translatedBtnClose = i18n.t( 'Close' );

    
    let translatedShareResultsWithDocotor = i18n.t( 'Share results with doctor?' );
    let translatedShareResultsExplain = i18n.t( 'We advise you to share this info with the doctor.' );
    let translatedYesShare = i18n.t( 'Yes, share' );
    let translatedDontShare = i18n.t( 'Dont share' );

    
    


    return (
      <div className={classNames}>
        <div className={classes2}>
          <div className="mdl-card__supporting-text mdl-card--border">
            <br />
            
            <BotChatBubble botTexts={botText} topicText={topicText} topicExtraClass={topicColorClass} botMood={this.props.botMood} resultsDemo={false} />
            {/**
            <div className="result-image-wrapper animate-pulse">
              <img className="result-image" src={resultLogo} />
            </div> 
            <div className="title">
              {resultstitle}
            </div>
            */}
            <TopicMatrix size="full" withDialogs="1" handleMatrixItemClick={this.handleExplainOpen} matrixContent={matrixContent} />
            
            <div className="text">
					
            </div>
          </div>
          
          
          <div className={actionClasses}>
            {this.state.canMoveBackwards && (
              <a className="mdc-button card-back-button"  onClick={(e) => this.handleMoveBack()} 
                href="#" >
                {translatedBtnBack}
              </a>
            )}
            
            {this.props.canFinish && (
              <a className="mdc-button card-finish-button" onClick={(e) => this.handleFinishRequest()}
                href="#" >
                {translatedBtnFinish}
              </a>
            )}

              <a className="mdc-button mdc-button--raised mdl-button--colored pull-right dm-btn-color--primary" onClick={(e) => this.handleFinish()} 
                href="#"
                >
                {translatedBtnFinish}
              </a>
            
          </div>
          
        </div>
        {/*
        <br />
        {this.props.showProgressBar && (
          <ProgressBar percentage={this.props.progress}></ProgressBar>
        )}
        <br />
        */}


        <div className={explainDialogClasses}>
          <dialog className="mdl-dialog" open="open" >
            <h4 className="mdl-dialog__title">{this.state.explainDialogTitle}</h4>
            <div className="mdl-dialog__content">
              
              <p className="infotext">{this.state.explainDialogContent}</p>
            
              <a type="button" 
                className="mdl-button mdl-js-button mdl-button--raised mdl-button mdl-button--primary close-expplain-modal close right"
                onClick={() =>
                  this.handleExplainClose()
                }
              >{translatedBtnClose}</a>
            </div>
            <div className="mdl-dialog__actions mdl-dialog__actions--full-width"></div>
          </dialog>
        </div>


        <div className={finishDialogClasses}>
          <dialog className="mdl-dialog" open="open" >
            <h4 className="mdl-dialog__title">{translatedShareResultsWithDocotor}</h4>
            <div className="mdl-dialog__content">
              
              <p className="infotext">
                {translatedShareResultsExplain}
              </p>
            
              <a type="button" 
                className="mdl-button mdl-js-button mdl-button--raised mdl-button pull-left close-ask-final-question close right"
                onClick={() =>
                  this.handleFinishClose()
                }
              >{translatedBtnClose}</a>


              <a type="button" 
                className="mdl-button mdl-js-button mdl-button--raised mdl-button pull-left btn-final-question-share pull-right mdl-button--primary  right"
                onClick={() =>
                  this.handleFinishSelected( 'completed' )
                }
              >{translatedYesShare}</a>

              <a type="button" 
                className="mdl-button mdl-js-button mdl-button--raised mdl-button pull-left btn-final-question-not-share pull-right mdl-button--secondary  right"
                onClick={() =>
                  this.handleFinishSelected( 'stopped' )
                }
              >{translatedDontShare}</a>

            </div>
            <div className="mdl-dialog__actions mdl-dialog__actions--full-width"></div>
          </dialog>
        </div>

        

      </div>
    );

  }

}

export default BotQuestionnaireResult;
